module.exports = __webpack_public_path__ + "static/img/food_menu_bg.a71da3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food_menu_bg.png
// module id = +u3R
// module chunks = 0